<section>

  <p>{{usersUpdateStatus}}</p>

    <div class="buttons-container">
  
<!--   
      <a *ngIf="isPilomatDev()" (click)="reSaveUsers()" class="button margin-right-20">
        <ng-container i18n="@@userslist_resave_users">Risalva utenti</ng-container> <span>
          <fa-icon icon="redo"></fa-icon>
        </span>
      </a>
  
  
      <a (click)="downloadCsv()" class="button margin-right-25" id="downloadCsvButton">
        <ng-container i18n="@@userslist_download_csv">Download CSV</ng-container> <span>
          <fa-icon icon="file-export"></fa-icon>
        </span>
      </a>
  
      <a (click)="searchByMethod()" class="button margin-right-25" id="searchByMethodButton">
        <ng-container i18n="@@userslist_search_method">Ricerca per metodo d'accesso</ng-container> <span>
          <fa-icon icon="search"></fa-icon>
        </span>
      </a>
     -->

     <a (click)="checkAll()" class="button">
        <!-- i18n="@@userslist_add_user" -->
        <ng-container>Seleziona tutti</ng-container> <span>
          <fa-icon icon="plus"></fa-icon>
        </span>
      </a>

      <a (click)="uncheckAll()" class="button">
        <!-- i18n="@@userslist_add_user" -->
        <ng-container>Deseleziona tutti</ng-container> <span>
          <fa-icon icon="minus"></fa-icon>
        </span>
      </a>

      <a (click)="resaveUsers()" class="button">
        <!-- i18n="@@userslist_add_user" -->
        <ng-container>Risalva selezionati</ng-container> <span>
          <fa-icon icon="user"></fa-icon>
        </span>
      </a>

    </div>

    <div class="table-filter">
        <p i18n="@@userslist_filter">Filtra: </p>
        <input id="filter-input" (keyup)="onKey($event)" />
    </div>

    <div class="table-container">

        <table mat-table matSort #userslisttable class="simple-table">

            <ng-container matColumnDef="checkbox">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@userslist_checkbox" style="width: 5%;">Nome</th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox (change)=addSelectedUser(element) [checked]=isUserSelected(element)>
                    </mat-checkbox>
                </td>
            </ng-container>


            <ng-container matColumnDef="name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@userslist_name" style="width: 30%;">Nome</th>
                <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@userslist_description" style="width: 27%;">Descrizione</th>
                <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
            </ng-container>

            <ng-container matColumnDef="groupName">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@userslist_group" style="width: 18%;">Gruppo</th>
                <td mat-cell *matCellDef="let element">{{element.groupName}}</td>
            </ng-container>

            <!-- <ng-container i18n="@@userslist_no_group" *ngIf="element.groupId == 0">
              Nessuno
            </ng-container>
            <ng-container *ngIf="element.groupId != 0">
              {{ getGroupNameById(element.groupId) }}
            </ng-container> -->

            <ng-container matColumnDef="user">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@userslist_email" style="width: 20%;">Abbonamento
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.userUid">
                        {{ element.user?.displayName }}
                    </ng-container>
                    <ng-container *ngIf="!element.userUid"><!--  -->
                        <ng-container i18n="@@userslist_user_not_linked" style="width: 10%;">App non attivata</ng-container>
                    </ng-container>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef i18n="@@userslist_code">Codice di attivazione</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="!element.userUid">
              {{ element.activationCode }}
            </ng-container>
            <ng-container *ngIf="element.userUid">
              <ng-container i18n="@@userslist_user_linked">Attivato</ng-container>
            </ng-container>
          </td>
        </ng-container> -->

            <ng-container matColumnDef="modifyUser">
                <th mat-header-cell *matHeaderCellDef i18n="@@adduserlist_tableHeader_modify"> </th>
                <td mat-cell *matCellDef="let element">
                    <fa-icon icon="edit" class="float-right padding-5 icon-clickable" (click)="onRowClicked(element)"></fa-icon>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="version">
                <th mat-header-cell *matHeaderCellDef i18n="@@userslist_type">Versione</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.systemInfo.version }}
                    <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
                </td>
            </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <!-- tutta la riga cliccabile
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
          [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
        </tr> -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

    </div>

    <app-loading-screen #userslistloader [loading]="true"></app-loading-screen>

</section>